/**
 * Shows a card's `ReorderHandle corner="end"` while the card is hovered or holds focus (the handle
 * shows itself on a touch screen and while dragged). Spread into the card's `sx` (TMMAPP-0154 item
 * 10).
 */
export const REVEAL_REORDER_HANDLE_SX = {
  '&:hover [data-reorder-handle], &:focus-within [data-reorder-handle]': { opacity: 1 },
} as const;
